export default "<block-ui>\r\n<router-outlet></router-outlet>\r\n</block-ui>\r\n\r\n\r\n\r\n"